"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.plugin = undefined;

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugin = exports.plugin = function plugin() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var plugin = {},
        nextState = {};

    switch (action.type) {
        case actionTypes.SET_ADOBE_AGENT:
            var csInterface = new CSInterface();

            nextState = (0, _merge2.default)({}, state);
            nextState.adobeAgent = csInterface.getHostEnvironment().appId;
            return (0, _merge2.default)({}, state, nextState);
            break;
        case actionTypes.SET_PLUGIN_PAGE:
            return (0, _merge2.default)({}, state, {
                page: action.page
            });
        case actionTypes.SET_PLUGIN_HOST:
            return (0, _merge2.default)({}, state, {
                host: action.host
            });
            break;
        default:
            return state;
            break;
    }

    return Object.assign({}, state, nextState);
};